import React, { Component } from 'react';
import { Formik, Field } from 'formik';
import { Redirect, Link } from 'react-router-dom';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { getAuthErr } from '../../js/utility';

import iconFB from '../../images/icons/icon_fb_white.png';
import iconGoogle from '../../images/icons/icon_google_white.png';

import { validateRequired } from '../../js/validators';

import { USER_NOT_CONFIRMED, SITE_TITLE } from '../../constants';

import { doSignIn, clearAuthError, redirect } from '../../actions/auth';
import { setSignupFlow, toggleActiveAuthPopUp } from '../../actions/contest';

class Login extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.clearAuthError();
  }

  render() {
    const {
      doSignIn,
      loading,
      authError,
      popupAuthError,
      t,
      contest,
      setSignupFlow,
      toggleActiveAuthPopUp
    } = this.props;

    return (
      <>
        <Helmet>
          <title>
            {t('form:login')} | {SITE_TITLE}
          </title>
        </Helmet>
        <h1 className='fe-auth-heading'>{t('form:login')}</h1>
        <div className='fe-auth-text'>{t('form:welcomeBack')}</div>
        <Formik
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            email: '',
            password: ''
          }}
          onSubmit={values => {
            doSignIn(values.email, values.password);
          }}
        >
          {({ handleSubmit }) => (
            <form noValidate onSubmit={handleSubmit} className='fe-form'>
              <div className='fe-form-content'>
                <div className='fe-form-field full'>
                  <label htmlFor='email'>{t('form:email')}</label>
                  <Field
                    name='email'
                    type='email'
                    validate={validateRequired}
                    component={CustomInput}
                  />
                </div>
                <div className='fe-form-field full'>
                  <label htmlFor='password'>{t('form:password')}</label>
                  <Field
                    type='password'
                    name='password'
                    isPassword
                    validate={validateRequired}
                    component={CustomInput}
                  />
                </div>
                <Button className='btn-auth' type='submit' disabled={loading}>
                  {loading ? `${t('form:loggingIn')}...` : t('form:login')}
                </Button>
              </div>
              <span className='fe-form-error'>
                {authError ? t(`error:${getAuthErr(authError.code)}`) : ''}
              </span>
            </form>
          )}
        </Formik>
        <div className='fe-auth-note'>
          {!contest ? (
            <a href='/forgot-password'>{t('form:forgotPassword')}?</a>
          ) : (
            <div onClick={() => setSignupFlow('resetPassword')}>
              {t('form:forgotPassword')}?
            </div>
          )}
        </div>
        <div className='fe-auth-note'>
          {!contest ? (
            <a href='/signup'>
              {t('form:dontHaveAcc')}? {t('form:signUp')}
            </a>
          ) : (
            <div onClick={() => setSignupFlow('signup')}>
              {t('form:dontHaveAcc')}? {t('form:signUp')}
            </div>
          )}
        </div>
        <div className='fe-auth-divider'>
          <span>{t('form:or')}</span>
        </div>
        <div className='fe-auth-social-buttons'>
          <Button
            className='btn-auth full facebook'
            preIcon={iconFB}
            onClick={() => {
              this.props.redirect();
              Auth.federatedSignIn({ provider: 'Facebook' });
            }}
          >
            {t('form:signInWith', { social: 'Facebook' })}
          </Button>
          <Button
            className='btn-auth full google'
            preIcon={iconGoogle}
            onClick={() => {
              this.props.redirect();
              Auth.federatedSignIn({ provider: 'Google' });
            }}
          >
            {t('form:signInWith', { social: 'Google' })}
          </Button>
        </div>
        <div
          className='fe-auth-note'
          dangerouslySetInnerHTML={{
            __html: t('form:socialSignInNote', {
              tnc: `<a href="/getaways/terms-and-conditions">${t(
                'form:tnc'
              )}</a>`
            })
          }}
        />
      </>
    );
  }
}

Login.propTypes = {
  clearAuthError: PropTypes.func.isRequired,
  doSignIn: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  authError: PropTypes.object,
  t: PropTypes.func.isRequired,
  redirect: PropTypes.func,
  setSignupFlow: PropTypes.func
};

const mapStateToProps = ({ authState, contestState }) => ({
  user: authState.user,
  authError: authState.authError,
  loading: authState.loading,
  contest: contestState.contestMode
});

const mapDispatchToProps = {
  doSignIn,
  clearAuthError,
  redirect,
  setSignupFlow
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
);
